import { createSlice } from "@reduxjs/toolkit";
import { AmenitiesSliceROWState } from "../types";
import { fetchApplicationROWDetails } from "../../application-section-row/application-details-row/redux/services/thunk/DetailsThunk";

const initialState: AmenitiesSliceROWState = {
  district: "",
  khasra_number: "",
  national_highway_number: "",
  villages_crossed_count: null,
  villages_crossed_names: null,
  tehsils_crossed_count: null,
  tehsils_crossed_names: null,
  pincode: "",
  state: "",
  category_id: 0,
  // terrain_classification: "",
  village: "",
  address_1: "",
  address_2: "",
  authority_name: "",
  access_id: 0,
  state_code: null,
  highway_side: "",
  utility_type: "",
  proposed_utility_alignment: 0,
  highway_category: "",
  amenity: "",
  gst_number: "",
  start_chainage_km: "",
  start_chainage_m: "",
  end_chainage_km: "",
  end_chainage_m: "",
  start_latitude: 0,
  start_longitude: 0,
  end_latitude: 0,
  end_longitude: 0,
  circle_rate: null,
  // ro_office_location: "",
  // piu_office_location: "",
  amenityCategory: 0,
  plot_length_m: "",
  plot_shape: "",
  plot_width_m: "",
  plot_area: "",
  authority_id: 0,
  start_chainage: "",
  end_chainage: "",
  ro_id: 0,
  piu_id: 0,
  piu_ids: [],
  application_id: "",
  taluka: "",
  // coordinates: {
  //   latitude: 0,
  //   longitude: 0
  // }
  isFirstSectionCompletedRow: false,
  chainage_Details: [],
  crossing_Details: [],
  other_utility_type: "",
};

const AmenitiesROWStateSlice = createSlice({
  name: "AmenitiesROWSlice",
  initialState,
  reducers: {
    setAmenityCategory(state, action) {
      state.amenityCategory = action.payload;
    },
    setLocationType(state, action) {
      state.amenityCategory = action.payload;
    },
    setAmenityROWField(state: any, action) {
      const { name, value } = action.payload;
      state[name] = value;
    },

    changeAmmenityUtilityType(state, action) {
      state.utility_type = action.payload;
    },
    setAmenityROWFields(state, action) {
      return {
        ...state,
        ...action.payload, // Merges all fields (including start_chainage_km etc.)
      };
    },
    setIsFirstSectionCompletedRow(state, action) {
      state.isFirstSectionCompletedRow = action.payload;
    },
    resetAmenityROWState(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationROWDetails.fulfilled, (state, action) => {
      state.category_id = action.payload?.utility_type_id || 0;
    });
  },
});

export const {
  setAmenityCategory,
  setLocationType,
  setAmenityROWField,
  changeAmmenityUtilityType,
  setAmenityROWFields,
  resetAmenityROWState,
  setIsFirstSectionCompletedRow,
} = AmenitiesROWStateSlice.actions;
export default AmenitiesROWStateSlice.reducer;
